function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "16.7 12.8 25.675 25.775",
    width: "29.061px",
    height: "29.2374px",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M41.7,34.6l-7.2-7.2c0.9-1.4,1.4-3.1,1.4-5c0-5.3-4.3-9.6-9.6-9.6s-9.6,4.3-9.6,9.6c0,5.3,4.3,9.6,9.6,9.6 c1.8,0,3.4-0.5,4.8-1.3l7.2,7.2c0.9,0.9,2.4,0.9,3.4,0C42.6,37.1,42.6,35.6,41.7,34.6z M20.5,22.5c0-3.2,2.6-5.8,5.7-5.8 c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.6,5.7-5.8,5.7C23.1,28.2,20.5,25.6,20.5,22.5z",
    style: {
      fill: "rgb(1, 1, 1)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.220ffbf7116fc9990f18a998f0f34608.svg";
export { ForwardRef as ReactComponent };